import BaseApi, { API_BASE_URL, ApiResponse } from './base';

export interface GlossaryTranslation {
  id: string;
  language: 'en' | 'es';
  definition: string;
  createdAt: string;
  updatedAt: string;
}

export interface Glossary {
  id: string;
  name: string;
  category?: {
    id: string;
    name: string;
  };
  aliases: string[];
  tags: string[];
  translations: GlossaryTranslation[];
  createdAt: string;
  updatedAt: string;
}

export interface CreateGlossaryRequest {
  name: string;
  categoryId?: string;
  aliases?: string[];
  tags?: string[];
  definition: string;
}

export interface UpdateGlossaryRequest {
  name?: string;
  categoryId?: string;
  aliases?: string[];
  tags?: string[];
  definition?: string;
}

class GlossariesApi extends BaseApi {
  constructor(baseURL: string = API_BASE_URL) {
    super(baseURL);
  }

  async getGlossaries(params?: {
    cursor?: string;
    limit?: number;
    categoryId?: string;
    search?: string;
    sortBy?: string;
    sortOrder?: 'asc' | 'desc';
    language?: string;
  }): Promise<ApiResponse<Glossary[]>> {
    return this.get<Glossary[]>(`/glossaries`, {
      params: params || {},
    });
  }

  async getGlossary(id: string, language?: string): Promise<ApiResponse<Glossary>> {
    return this.get<Glossary>(`/glossaries/${id}`, {
      params: language ? { lang: language } : {},
    });
  }

  async createGlossary(data: CreateGlossaryRequest): Promise<ApiResponse<Glossary>> {
    return this.post<Glossary>('/glossaries', data);
  }

  async updateGlossary(id: string, data: UpdateGlossaryRequest): Promise<ApiResponse<Glossary>> {
    return this.put<Glossary>(`/glossaries/${id}`, data);
  }

  async deleteGlossary(id: string): Promise<ApiResponse<{}>> {
    return this.delete<{}>(`/glossaries/${id}`);
  }

  async bulkDeleteGlossaries(ids: string[]): Promise<ApiResponse<{ deleted: number; failed: string[] }>> {
    return this.post<{ deleted: number; failed: string[] }>('/glossaries/bulk/delete', { ids });
  }
}

export default new GlossariesApi();

